'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _dec, _dec2, _dec3, _class, _class2, _temp2;

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _LocalExpertProfile = require('./LocalExpertProfile.scss');

var _LocalExpertProfile2 = _interopRequireDefault(_LocalExpertProfile);

var _reactIntl = require('react-intl');

var _reactScroll = require('react-scroll');

var _reactScroll2 = _interopRequireDefault(_reactScroll);

var _reactRedux = require('react-redux');

var _reduxAsyncConnect = require('redux-async-connect');

var _lxprofile = require('redux/modules/lxprofile');

var lxProfileAction = _interopRequireWildcard(_lxprofile);

var _RatingPoint = require('components/General/RatingPoint/RatingPoint');

var _RatingPoint2 = _interopRequireDefault(_RatingPoint);

var _VerifyStatus = require('components/LocalExpertProfile/VerifyStatus');

var _VerifyStatus2 = _interopRequireDefault(_VerifyStatus);

var _LocalExpertTrips = require('components/LocalExpertProfile/LocalExpertTrips');

var _LocalExpertTrips2 = _interopRequireDefault(_LocalExpertTrips);

var _Reviews = require('components/Review/Reviews');

var _Reviews2 = _interopRequireDefault(_Reviews);

var _Modal = require('components/General/Modal/Modal');

var _Modal2 = _interopRequireDefault(_Modal);

var _Product = require('components/StructuredData/Product');

var _Product2 = _interopRequireDefault(_Product);

var _Breadcrumbs = require('components/Breadcrumbs/Breadcrumbs');

var _Breadcrumbs2 = _interopRequireDefault(_Breadcrumbs);

var _helpers = require('utils/helpers');

var _media = require('utils/media');

var _calendar = require('utils/calendar');

var _initialLoadSuccess = require('redux/modules/initialLoadSuccess');

var _redirect = require('redux/modules/redirect');

var _momentTimezone = require('moment-timezone');

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
  LocalExpertProfile: {
    displayName: 'LocalExpertProfile'
  }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
  filename: '/home/runner/work/redux-frontend/redux-frontend/src/containers/LocalExpertProfile/LocalExpertProfile.js',
  components: _components,
  locals: [],
  imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
  return function (Component) {
    return _reactTransformCatchErrors2(Component, id);
  };
}

var ScrollLink = _reactScroll2.default.Link;
var Element = _reactScroll2.default.Element;

_momentTimezone2.default.tz.setDefault('Asia/Bangkok');

var LocalExpertProfile = _wrapComponent('LocalExpertProfile')((_dec = (0, _reduxAsyncConnect.asyncConnect)([{
  promise: function promise(_ref) {
    var _ref$store = _ref.store,
        dispatch = _ref$store.dispatch,
        getState = _ref$store.getState,
        slug = _ref.params.slug;

    if (!(0, _lxprofile.isLoaded)(getState())) {
      return dispatch((0, _lxprofile.load)(slug)).then(function (res) {
        if (res.is_redirect) {
          return dispatch((0, _redirect.setRedirectedPath)('/local-expert/' + res.slug));
        }
      }).catch(function () {
        return dispatch((0, _initialLoadSuccess.loadFailed)());
      });
    }
  }
}]), _dec2 = (0, _reactRedux.connect)(function (state) {
  return {
    lxprofile: state.lxprofile.data,
    error: state.lxprofile.error,
    loading: state.lxprofile.loading,
    locale: state.language.locale
    // locale: state.language.locale,
  };
}, lxProfileAction), _dec3 = (0, _reactCssModules2.default)(_LocalExpertProfile2.default), _dec(_class = _dec2(_class = _dec3(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(LocalExpertProfile, _Component);

  function LocalExpertProfile() {
    var _ref2;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, LocalExpertProfile);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref2 = LocalExpertProfile.__proto__ || (0, _getPrototypeOf2.default)(LocalExpertProfile)).call.apply(_ref2, [this].concat(args))), _this), _this.state = {
      isOpenModal: false,
      openVerifyModal: false
    }, _this.openModal = function () {
      _this.setState({ isOpenModal: true });
    }, _this.closeModal = function () {
      _this.setState({ isOpenModal: false });
    }, _this.openVerifyModal = function () {
      _this.setState({ openVerifyModal: true });
    }, _this.closeVerifyModal = function () {
      _this.setState({ openVerifyModal: false });
    }, _this.checkFaq = function () {
      var lxprofile = _this.props.lxprofile;

      var check = false;
      lxprofile.faqs.map(function (f) {
        if (f.question && f.answer) {
          check = true;
        }
      });
      return check;
    }, _this.isVerified = function () {
      var lxprofile = _this.props.lxprofile;

      var count = 0;
      if (lxprofile && lxprofile.verification) {
        if (lxprofile.verification.mobile_verified) {
          count += 1;
        }
        if (lxprofile.verification.id_card_verified) {
          count += 1;
        }
        if (lxprofile.verification.email_verified) {
          count += 1;
        }
        if (lxprofile.verification.facebook_verified) {
          count += 1;
        }
      }
      if (count >= 2) {
        return true;
      }
      return false;
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(LocalExpertProfile, [{
    key: 'render',
    value: function render() {
      // const badgeVerifyImage = require('theme/images/icons/badge-verify.png');
      var defaultImage = require('theme/images/default-img.png');
      // const {lxprofile, locale} = this.props;
      var _props = this.props,
          lxprofile = _props.lxprofile,
          locale = _props.locale;

      var coverImage = lxprofile.trips && lxprofile.trips.length > 0 && lxprofile.trips[0].cover_image || null;
      return _react3.default.createElement(
        'div',
        { styleName: 'main-container' },
        _react3.default.createElement(_reactHelmet2.default, { title: lxprofile.name && lxprofile.name.first + ' ' + lxprofile.name.last + ' | ',
          meta: [{ 'property': 'og:image', 'content': coverImage && (0, _media.path)(lxprofile.trips[0].cover_image, 'profileCover') }, { 'property': 'og:description', 'content': lxprofile.profile && lxprofile.profile.about_me }, { 'property': 'og:site_name', 'content': 'TakeMeTour - ' + (lxprofile.name && lxprofile.name.first + ' ' + lxprofile.name.last) }, { 'property': 'description', 'content': lxprofile.profile && lxprofile.profile.about_me }]
        }),
        _react3.default.createElement(_Product2.default, {
          name: lxprofile.name && lxprofile.name.first + ' ' + lxprofile.name.last,
          ratingValue: lxprofile.rating.average_rating,
          reviewCount: lxprofile.reviews.length
        }),
        _react3.default.createElement(
          _Modal2.default,
          { centerVertical: true, isOpen: this.state.isOpenModal, style: { 'maxWidth': '500px', 'padding': '0', 'borderRadius': '0', 'margin': '0 auto' }, onClose: this.closeModal, closeStyle: 'btn-close-absolute', id: 'lx-profile-pic' },
          _react3.default.createElement('img', { src: (0, _media.path)(lxprofile.avatar_image, 'modalImage'), styleName: 'modal-img', alt: lxprofile.name && lxprofile.name.first + ' ' + lxprofile.name.last })
        ),
        _react3.default.createElement(
          _Modal2.default,
          { isOpen: this.state.openVerifyModal, onClose: this.closeVerifyModal, centerVertical: true, style: { padding: '0' }, id: 'verify-lx-modal' },
          _react3.default.createElement(
            'div',
            null,
            _react3.default.createElement(
              'h3',
              null,
              _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'lx_profile.verified.header' })
            ),
            _react3.default.createElement(
              'div',
              { styleName: 'verify-modal-content' },
              _react3.default.createElement(
                'p',
                null,
                _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'lx_profile.verified.tool_tip',
                  values: { lxName: lxprofile && lxprofile.name && lxprofile.name.first + ' ' + lxprofile.name.last }
                })
              ),
              _react3.default.createElement(
                'p',
                { styleName: 'tooltip-link' },
                _react3.default.createElement(
                  'a',
                  { href: 'https://www.takemetour.com/help-center/traveler?topic=&index=3', target: '_blank' },
                  _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'lx_profile.verified.learn_more' }),
                  ' ',
                  _react3.default.createElement('i', { styleName: 'next-icon' })
                )
              )
            )
          )
        ),
        _react3.default.createElement(
          'div',
          { styleName: 'banner', style: coverImage && (0, _media.path)(lxprofile.trips[0].cover_image, 'profileCover', true) },
          _react3.default.createElement(
            'div',
            { styleName: 'banner-content' },
            _react3.default.createElement(
              'div',
              { styleName: 'profile-picture' },
              _react3.default.createElement('img', { src: lxprofile.avatar_image ? (0, _media.path)(lxprofile.avatar_image, 'profileAvatar') : defaultImage, alt: lxprofile.name && lxprofile.name.first + ' ' + lxprofile.name.last })
            )
          )
        ),
        _react3.default.createElement(
          'div',
          { styleName: 'profile-bg' },
          _react3.default.createElement(
            'div',
            { styleName: 'inner' },
            _react3.default.createElement(_Breadcrumbs2.default, { type: 'LocalExpertProfile', localExpert: lxprofile, customStyle: { paddingLeft: '25px', marginTop: '-100px', marginBottom: '100px' } }),
            _react3.default.createElement(
              'div',
              { styleName: 'flex-row' },
              _react3.default.createElement(
                'div',
                { styleName: 'lx-profile-container' },
                _react3.default.createElement(
                  'h1',
                  null,
                  lxprofile.name && lxprofile.name.first + ' ' + lxprofile.name.last
                ),
                _react3.default.createElement(
                  'p',
                  null,
                  lxprofile.profile && lxprofile.profile.current_city && lxprofile.profile.current_city + ', ',
                  lxprofile.last_country || 'Thailand',
                  _react3.default.createElement('br', { styleName: 'mobile-newline' }),
                  _react3.default.createElement(
                    'span',
                    { styleName: 'gray-text' },
                    _react3.default.createElement(
                      'span',
                      { styleName: 'divider' },
                      '|'
                    ),
                    _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'lx_profile.member_since' }),
                    ' ',
                    (0, _momentTimezone2.default)(lxprofile.created_at).format((0, _calendar.getMYFormat)(locale))
                  )
                ),
                lxprofile.response && _react3.default.createElement(
                  'div',
                  { styleName: 'response' },
                  _react3.default.createElement(
                    'div',
                    { styleName: 'response-item' },
                    _react3.default.createElement(
                      'p',
                      { styleName: 'gray-text' },
                      _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'lx_profile.response_rate' })
                    ),
                    _react3.default.createElement(
                      'p',
                      { styleName: 'weight-400' },
                      (0, _helpers.getResponse)(lxprofile.response).rate
                    )
                  ),
                  _react3.default.createElement(
                    'div',
                    { styleName: 'response-item' },
                    _react3.default.createElement(
                      'p',
                      { styleName: 'gray-text' },
                      _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'lx_profile.response_time' })
                    ),
                    _react3.default.createElement(
                      'p',
                      { styleName: 'weight-400' },
                      (0, _helpers.getResponse)(lxprofile.response).time
                    )
                  )
                ),
                _react3.default.createElement(
                  'div',
                  { styleName: 'verify-row' },
                  this.isVerified() && [_react3.default.createElement(
                    'div',
                    { styleName: 'verify-item-mobile', onClick: this.openVerifyModal, key: 1 },
                    _react3.default.createElement('div', { styleName: 'verify-icon' }),
                    _react3.default.createElement(
                      'p',
                      { styleName: 'weight-400' },
                      _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'lx_profile.verified.header' })
                    )
                  ), _react3.default.createElement(
                    'div',
                    { styleName: 'verify-item-desktop', key: 2 },
                    _react3.default.createElement('div', { styleName: 'verify-icon' }),
                    _react3.default.createElement(
                      'p',
                      { styleName: 'weight-400' },
                      _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'lx_profile.verified.header' })
                    ),
                    _react3.default.createElement(
                      'div',
                      { styleName: 'tooltip' },
                      _react3.default.createElement(
                        'div',
                        { styleName: 'tooltip-header-container' },
                        _react3.default.createElement('i', { styleName: 'inspiration-icon' }),
                        _react3.default.createElement(
                          'span',
                          { styleName: 'tooltip-header' },
                          _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'lx_profile.verified.header' })
                        )
                      ),
                      _react3.default.createElement(
                        'p',
                        { styleName: 'tooltip-content' },
                        _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'lx_profile.verified.tool_tip',
                          values: { lxName: lxprofile && lxprofile.name && lxprofile.name.first + ' ' + lxprofile.name.last }
                        })
                      ),
                      _react3.default.createElement(
                        'p',
                        { styleName: 'tooltip-link' },
                        _react3.default.createElement(
                          'a',
                          { href: 'https://www.takemetour.com/help-center/traveler?topic=&index=3', target: '_blank' },
                          _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'lx_profile.verified.learn_more' }),
                          ' ',
                          _react3.default.createElement('i', { styleName: 'next-icon' })
                        )
                      )
                    )
                  )],
                  lxprofile.verification && lxprofile.verification.has_badge && _react3.default.createElement(
                    'div',
                    { styleName: 'verify-item' },
                    _react3.default.createElement('div', { styleName: 'super-lx-icon' }),
                    _react3.default.createElement(
                      'p',
                      { styleName: 'weight-400' },
                      _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'lx_profile.super_lx.header' })
                    )
                  )
                ),
                _react3.default.createElement(
                  'p',
                  null,
                  lxprofile.profile && lxprofile.profile.about_me
                )
              )
            ),
            lxprofile.rating.count ? _react3.default.createElement(
              'div',
              { styleName: 'point-text-container' },
              _react3.default.createElement(
                'div',
                { styleName: 'point-container-mobile' },
                _react3.default.createElement(_RatingPoint2.default, { point: lxprofile.rating.score / lxprofile.rating.count })
              ),
              _react3.default.createElement(
                'h5',
                { styleName: 'point-text' },
                _react3.default.createElement(
                  'span',
                  { styleName: 'bold' },
                  _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'lx_profile.rating.overall' }),
                  ' ',
                  _react3.default.createElement(
                    'span',
                    { styleName: 'hilight' },
                    (0, _helpers.getRatingPoint)(lxprofile.rating.score / lxprofile.rating.count)
                  ),
                  '/5'
                ),
                _react3.default.createElement(
                  'div',
                  { styleName: 'point-container-desktop' },
                  _react3.default.createElement(_RatingPoint2.default, { point: lxprofile.rating.score / lxprofile.rating.count })
                ),
                _react3.default.createElement(
                  'span',
                  { styleName: 'hilight' },
                  _react3.default.createElement(
                    ScrollLink,
                    { to: 'allReview', smooth: true, offset: -80, duration: 500 },
                    _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'lx_profile.all_reviews' })
                  )
                )
              )
            ) : null,
            _react3.default.createElement(_VerifyStatus2.default, {
              mobileVerified: lxprofile.verification && lxprofile.verification.mobile_verified,
              idCardVerified: lxprofile.verification && lxprofile.verification.id_card_verified,
              socialVerified: lxprofile.verification && lxprofile.verification.facebook_verified,
              emailVerified: lxprofile.verification && lxprofile.verification.email_verified
            })
          )
        ),
        _react3.default.createElement(
          'div',
          { styleName: 'inner' },
          this.checkFaq() && _react3.default.createElement(
            'div',
            { styleName: 'more-info-container' },
            _react3.default.createElement(
              'h2',
              null,
              _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'lx_profile.more_info' })
            ),
            _react3.default.createElement(
              'div',
              { styleName: 'more-info-content' },
              lxprofile.faqs.map(function (faq, index) {
                if (faq.question && faq.answer) {
                  return _react3.default.createElement(
                    'div',
                    { styleName: 'more-info-column', key: 'faq-' + index },
                    _react3.default.createElement(
                      'h3',
                      null,
                      faq.question
                    ),
                    _react3.default.createElement(
                      'p',
                      null,
                      faq.answer
                    )
                  );
                }
              })
            )
          ),
          _react3.default.createElement(_LocalExpertTrips2.default, { lxName: lxprofile.name, trips: lxprofile.trips })
        ),
        _react3.default.createElement(Element, { name: 'allReview' }),
        lxprofile.reviews && lxprofile.reviews.length > 0 && _react3.default.createElement(
          'div',
          { styleName: 'reviews-container' },
          _react3.default.createElement(_Reviews2.default, { reviews: lxprofile.reviews, lxName: lxprofile.name.first, woReview: lxprofile.travelers_without_review })
        )
      );
    }
  }]);
  return LocalExpertProfile;
}(_react2.Component), _class2.propTypes = {
  lxprofile: _react2.PropTypes.object,
  error: _react2.PropTypes.string,
  loading: _react2.PropTypes.bool,
  load: _react2.PropTypes.func.isRequired,
  locale: _react2.PropTypes.string
  // locale: PropTypes.string,
}, _temp2)) || _class) || _class) || _class));

exports.default = LocalExpertProfile;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/LocalExpertProfile/LocalExpertProfile.js
// module id = 676
// module chunks = 2